import { render } from "./ylyBasicDataConifg.vue?vue&type=template&id=4f609475&scoped=true"
import script from "./ylyBasicDataConifg.vue?vue&type=script&lang=js"
export * from "./ylyBasicDataConifg.vue?vue&type=script&lang=js"

import "./ylyBasicDataConifg.vue?vue&type=style&index=0&id=4f609475&lang=scss&scoped=true"

import exportComponent from "D:\\work\\qianduan\\operation-system\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f609475"]])

export default __exports__